import axios from 'axios';
import { BASE_URL } from '../Config';

export async function getCampaign(campaignId) {
    try {
        const response = await axios.get(`${BASE_URL}/api/campaign/campaign/${campaignId}`);
        return response?.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}